var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FF"
    },
    d: "M395.13,0H116.87c-9.18,0-16.696,7.477-16.696,16.696v144.696c0,9.214,7.482,16.696,16.696,16.696 H395.13c9.214,0,16.696-7.482,16.696-16.696V16.696C411.826,7.534,404.368,0,395.13,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M395.13,0H256v178.087h139.13c9.214,0,16.696-7.482,16.696-16.696V16.696 C411.826,7.534,404.368,0,395.13,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#144F9B"
    },
    d: "M495.304,144.696H16.696C7.516,144.696,0,152.173,0,161.391c0,84.581,0,149.158,0,233.739 c0,9.218,7.516,16.696,16.696,16.696h478.609c9.179,0,16.696-7.477,16.696-16.696c0-84.581,0-149.158,0-233.739 C512,152.173,504.484,144.696,495.304,144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003F84"
    },
    d: "M495.304,144.696H256v267.13h239.304c9.179,0,16.696-7.477,16.696-16.696 c0-84.581,0-149.158,0-233.739C512,152.173,504.484,144.696,495.304,144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FF"
    },
    d: "M395.13,278.261H116.87c-9.18,0-16.696,7.477-16.696,16.696v200.348 c0,9.214,7.482,16.696,16.696,16.696H395.13c9.157,0,16.696-7.463,16.696-16.696V294.957 C411.826,285.738,404.311,278.261,395.13,278.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BBFF"
    },
    d: "M183.652,378.435h144.696c9.22,0,16.696-7.475,16.696-16.696c0-9.222-7.475-16.696-16.696-16.696 H183.652c-9.222,0-16.696,7.474-16.696,16.696C166.957,370.96,174.431,378.435,183.652,378.435"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M395.13,278.261H256V512h139.13c9.157,0,16.696-7.463,16.696-16.696V294.957 C411.826,285.738,404.311,278.261,395.13,278.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BBFF"
    },
    d: "M183.652,445.217H256c9.22,0,16.696-7.475,16.696-16.696c0-9.222-7.475-16.696-16.696-16.696h-72.348 c-9.222,0-16.696,7.474-16.696,16.696C166.957,437.742,174.431,445.217,183.652,445.217"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9FD9"
    },
    d: "M256,411.826v33.391c9.22,0,16.696-7.475,16.696-16.696C272.696,419.299,265.22,411.826,256,411.826 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9FD9"
    },
    d: "M328.348,345.043H256v33.391h72.348c9.22,0,16.696-7.475,16.696-16.696 C345.043,352.516,337.568,345.043,328.348,345.043z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CFDBE6"
    },
    cx: 361.739,
    cy: 228.174,
    r: 16.696
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#66B31B"
    },
    cx: 428.522,
    cy: 228.174,
    r: 16.696
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.649fdf23a202471db4f9640ccda90805.svg";
export { ForwardRef as ReactComponent };